import Reveal from "../Reveal";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-36 border-t border-[#E2DCD0] bg-[#F2EFEB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <div className="overflow-hidden aspect-[3/4] border border-[#E2DCD0]">
                <img
                  src="https://customer-assets.emergentagent.com/job_brief-storytelling/artifacts/ym1w7uvx_Rach.jpg"
                  alt="Rachel, founder of All We Do Is Write, smiling warmly in natural light"
                  className="w-full h-full object-cover transition-transform duration-[2000ms] hover:scale-105"
                  loading="lazy"
                />
              </div>
              <p className="mt-4 text-xs italic text-[#475569]">
                Rachel — Founder, All We Do Is Write.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7 lg:pt-8">
            <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#C86A53] mb-8">
              05 — About Rachel
            </p>
            <h2
              data-testid="about-headline"
              className="font-display font-light tracking-tighter leading-[0.95] text-[#0F172A] text-5xl md:text-6xl"
            >
              Helping organisations find the <span className="italic">stories</span> that matter.
            </h2>

            <div className="mt-10 space-y-5 text-lg leading-relaxed font-light text-[#475569]">
              <p>
                With more than 20 years' experience spanning journalism, communications,
                education and engagement, Rachel has helped dozens of organisations
                build trust, strengthen relationships and communicate with confidence.
              </p>
              <p>
                From national campaigns and award-winning storytelling to community
                engagement and culture change, her award-winning work has always
                started with one belief:
              </p>
            </div>

            <p className="mt-8 font-display italic text-3xl md:text-4xl text-[#0F172A] leading-snug border-t border-[#E2DCD0] pt-8">
              Every organisation has stories worth telling.
              <br />
              Sometimes they just need help finding them.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 border-t border-[#E2DCD0] pt-8 gap-6 sm:gap-4">
              {[
                { n: "20+ Years", l: "Helping organisations communicate" },
                { n: "Award-winning", l: "Storytelling & engagement" },
                { n: "Thousands", l: "Of stories shared" },
              ].map((s) => (
                <div key={s.l}>
                  <p className="font-display text-2xl md:text-3xl text-[#C86A53] font-light leading-tight">
                    {s.n}
                  </p>
                  <p className="mt-2 text-xs uppercase tracking-[0.18em] text-[#475569] leading-snug">
                    {s.l}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
